import {
  ContentBlockLocation,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {ContentBlocksSourceType, useTrackPromotion} from '@aboutyou/tracking';

export interface ContentBlockPromotionTrackingInterface {
  locationBlockType: ContentBlockLocation;
  contentBlockSource: ContentBlocksSourceType;
  actionType: 'click' | 'impression';
  path: {url: string; external: boolean};
  blockId?: number;
  promotionName?: string;
  promotionId?: string;
  streamPosition?: number;
  elementPosition?: number;
}

export const useContentBlockPromotionTracking = () => {
  const trackPromotionClick = useTrackPromotion();

  return ({
    locationBlockType,
    contentBlockSource,
    actionType,
    path,
    blockId,
    promotionName,
    promotionId,
    streamPosition = 0,
    elementPosition,
  }: ContentBlockPromotionTrackingInterface) => {
    trackPromotionClick({
      // streamPosition will take the place of the content block, plus the number of the cta like -> 1.1 -> first colum, first CTA
      streamPosition: elementPosition
        ? streamPosition + elementPosition / 10
        : streamPosition,
      promotion: {
        source: TrackingPromotionCreative.CustomPage,
        id: promotionId || '',
        name: promotionName || '',
        locationId: `${locationBlockType}${blockId ? '_' + blockId : ''}`,
        path,
        contentBlockSource,
      },
      actionType,
    });
  };
};
